module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraBold.2af552e.eot";